import { pathOr } from 'ramda';

import { IState } from '../../store';

export const getNewbuildingDeveloper = (state: IState) => {
  return pathOr(null, ['offerData', 'newObject', 'developer'], state);
};
